import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withFetch,
    withInterceptorsFromDi
} from '@angular/common/http';
import {
    provideRouter,
    withEnabledBlockingInitialNavigation,
    withInMemoryScrolling
} from '@angular/router';

import { routes } from './app.routes';
import {
    provideClientHydration,
    withEventReplay,
    withNoHttpTransferCache
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { definePreset } from '@primeng/themes';
import { TransferHttpCacheInterceptor } from './interceptors/transfer-http-cache/transfer-http-cache.interceptor';
import { BaseUrlInterceptor } from './interceptors/base-url/base-url.interceptor';
import { LogInterceptor } from './interceptors/log/log.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withEnabledBlockingInitialNavigation(),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
        ),
        provideClientHydration(withEventReplay(), withNoHttpTransferCache()),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TransferHttpCacheInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BaseUrlInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LogInterceptor,
            multi: true
        },
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: definePreset(Lara, {
                    semantic: {
                        primary: {
                            50: '{slate.50}',
                            100: '{slate.100}',
                            200: '{slate.200}',
                            300: '{slate.300}',
                            400: '{slate.400}',
                            500: '#020b5b',
                            600: '#020b5b',
                            700: '#020b5b',
                            800: '{slate.800}',
                            900: '{slate.900}',
                            950: '{slate.950}'
                        }
                    }
                }),
                options: {
                    darkModeSelector: false,
                    cssLayer: {
                        name: 'primeng',
                        order: 'tailwind-base, primeng, tailwind-utilities'
                    }
                }
            }
        })
    ]
};
